const NEAR_BOTTOM_PX = 120

function isNearBottom(el) {
  return el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX
}

export default {
  mounted() {
    this.stick = true
    this.newMessages = this.el.closest('.aios-chat-scroller')?.querySelector('[data-aios-new-messages]')
    this.contentSignature = this._contentSignature()
    this.onNewMessages = () => {
      this.stick = true
      this._showNewMessages(false)
      this.el.scrollTo({top:this.el.scrollHeight,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})
    }
    this.newMessages?.addEventListener('click',this.onNewMessages)
    this.onScroll = () => {
      this.stick = isNearBottom(this.el)
      if(this.stick) this._showNewMessages(false)
    }
    this.el.addEventListener("scroll", this.onScroll, { passive: true })
    this.scrollToBottom()
  },
  updated() {
    // Controls can change without chat content changing. Inspect only the
    // last real message; no document-wide observer or polling is necessary.
    const signature = this._contentSignature()
    if(!this.stick && signature !== this.contentSignature) this._showNewMessages(true)
    this.contentSignature = signature
    if (this.stick) this.scrollToBottom()
  },
  _contentSignature() {
    if(!this.newMessages) return null
    const last=this.el.querySelector('.aios-transcript')?.lastElementChild
    return last ? `${last.id}:${last.textContent.length}` : ''
  },
  _showNewMessages(show) {
    if(!this.newMessages) return
    this.newMessages.dataset.show=String(show)
    this.newMessages.hidden=!show
  },
  // Defer to the next frame so content that lays out late (streamed
  // markdown, code blocks, images) is measured before we pin to the bottom.
  scrollToBottom() {
    cancelAnimationFrame(this.scrollFrame)
    this.scrollFrame = requestAnimationFrame(() => {
      this.el.scrollTop = this.el.scrollHeight
    })
  },
  destroyed() {
    cancelAnimationFrame(this.scrollFrame)
    this.newMessages?.removeEventListener('click',this.onNewMessages)
    if (this.onScroll) this.el.removeEventListener("scroll", this.onScroll)
  }
}
